var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cropper',{ref:"imageCrop",attrs:{"lang-type":"en","width":_vm.width,"height":_vm.height,"noCircle":true},on:{"crop-success":_vm.onCropSuccess},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }